import {
  action,
  computed,
  observable,
  set,
  toJS,
  isObservable,
  isObservableProp,
  observe,
  keys,
  isObservableObject,
  isObservableArray,
} from "mobx";

class Model {
  /**
   * @private
   */
  #dirtyFields = [];

  /**
   * @private
   */
  #parent;

  /**
   * @private
   */
  #parentFieldName;

  /**
   * @returns {boolean}
   */
  @computed
  get isDirty() {
    return !!this.#dirtyFields.length;
  }

  #excludeIntercept = ["#dirtyFields"];

  constructor(data, parent, parentFieldName) {
    if (data !== undefined) {
      this.setData(data);
      this.resetDirty();
    }
    if (parent !== undefined) {
      this.#parent = parent;
      if (parentFieldName !== undefined) {
        this.#parentFieldName = parentFieldName;
      } else {
        throw new Error("fieldName cannot be undefined. Please provide the variable name used in parent");
      }
    }

    const prototypes = keys(this);
    prototypes.forEach(proto => {
      if (!isObservable(this[proto]) && !isObservableProp(this, proto)) {
        return;
      }
      if (this.#excludeIntercept.includes(proto)) {
        return;
      }
      if (isObservableObject(this[proto]) || isObservableArray(this[proto])) {
        observe(this[proto], () => {
          this.hasUpdated(proto);
        });
      } else {
        observe(this, proto, () => {
          this.hasUpdated(proto);
        });
      }
    });
  }

  hasUpdated(prop) {
    if (this.#dirtyFields.indexOf(prop) === -1) {
      this.#dirtyFields.push(prop);
    }
    if (this.#parent) {
      if (this.#parent.#dirtyFields.indexOf(this.#parentFieldName) === -1) {
        this.#parent.#dirtyFields.push(this.#parentFieldName);
      }
    }
  }

  /**
   * Return an object
   * @returns {object}
   */
  @action
  getDirtyData() {
    const payload = {};

    this.#dirtyFields.forEach(field => {
      if (this[field] instanceof Model) {
        payload[field] = this[field].getDirtyData();
      }

      // this probably don't work but not required for now
      if (isObservableArray(this[field])) {
        payload[field] = this[field].map(currentField => {
          if (currentField instanceof Model) {
            return currentField.getDirtyData();
          }
          return toJS(currentField);
        });
        return;
      }
      payload[field] = toJS(this[field]);
    });
    return payload;
  }

  resetDirty() {
    this.#dirtyFields = observable([]);
  }

  @action
  setData(data) {
    set(this, data);
  }
}
export default Model;
